const HeroSection = () => {
  return (
    <section className="relative overflow-hidden py-20 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-8">
      {/* Academic gradient background */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, var(--color-theme-1), var(--color-theme-2))'
        }}
      >
        {/* Floating academic elements */}
        <div
          className="absolute top-20 left-10 w-64 h-64 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-float"
          style={{ backgroundColor: 'var(--color-accent-3)' }}
        ></div>
        <div
          className="absolute bottom-20 right-10 w-80 h-80 rounded-full mix-blend-multiply filter blur-3xl opacity-15 animate-float-delay"
          style={{ backgroundColor: 'var(--color-accent-2)' }}
        ></div>
      </div>

      <div className="container mx-auto relative z-10 max-w-7xl">
        <div className="text-left md:text-center space-y-8">
          {/* Hero Content */}
          <div className="space-y-6">
            <h1
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-extrabold tracking-tight"
              style={{ color: 'var(--color-heading)' }}
            >
              Academic Excellence
            </h1>
            <p
              className="text-lg sm:text-xl md:text-2xl font-semibold max-w-3xl md:mx-auto"
              style={{ color: 'var(--color-subheading)' }}
            >
              Distinguished Scholar with High Honors & National Recognition
            </p>
          </div>

          {/* Key Highlights */}
          <div className="flex flex-wrap justify-start md:justify-center items-center gap-4 pt-6">
            <div
              className="px-6 py-3 rounded-full shadow-card"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-accent-5)',
                borderWidth: '1px',
                borderStyle: 'solid'
              }}
            >
              <span className="font-bold" style={{ color: 'var(--color-accent-6)' }}>
                AP Scholar with Distinction
              </span>
            </div>
            <div
              className="px-6 py-3 rounded-full shadow-card"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-accent-5)',
                borderWidth: '1px',
                borderStyle: 'solid'
              }}
            >
              <span className="font-bold" style={{ color: 'var(--color-accent-6)' }}>
                National Honor Society
              </span>
            </div>
            <div
              className="px-6 py-3 rounded-full shadow-card"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-accent-5)',
                borderWidth: '1px',
                borderStyle: 'solid'
              }}
            >
              <span className="font-bold" style={{ color: 'var(--color-accent-6)' }}>
                IASAS Scholar Award
              </span>
            </div>
          </div>

          <p
            className="text-lg leading-relaxed max-w-3xl md:mx-auto pt-4"
            style={{ color: 'var(--color-subtle)' }}
          >
            A consistent top academic performer demonstrating exceptional dedication across multiple disciplines,
            with particular distinction in mathematics. Recognized nationally and internationally for academic
            achievements and scholarly contributions.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0); }
          50% { transform: translateY(-20px) translateX(10px); }
        }
        @keyframes float-delay {
          0%, 100% { transform: translateY(0) translateX(0); }
          50% { transform: translateY(20px) translateX(-10px); }
        }
        .animate-float {
          animation: float 10s ease-in-out infinite;
        }
        .animate-float-delay {
          animation: float-delay 12s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};

export default HeroSection;
